import { FC } from 'react';
import PostComposerContentText from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentText';
import { PostComposerContentProps } from 'app/modules/posts/modules/post/components/composer/PostComposerContent';
import PostComposerContentMediaAttachments from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentMediaAttachemnts';
import PostsConfig from 'app/config/posts';
import PostComposerContentPinterestLinkForm from 'app/modules/posts/modules/post/components/composer/postComposerContent/postComposerContentPinterest/PostComposerContentPinterestLinkForm';
import useSetState from 'utils/hooks/useSetState';
import { TYPE as POST_TYPE } from '@kontentino/kontentino-constants/Posts';

type Props = PostComposerContentProps;

const PostComposerContentPinterest: FC<Props> = ({
  value,
  onChange,
  onTextEditorInit,
  onTranslationEditorInit,
  swapTextTranslation,
}) => {
  const isVideo = value.type === POST_TYPE.VIDEO;

  const [persistedValues, setPersistedValues] = useSetState<{
    url: string;
    title: string;
  }>({
    url: value.attachments.cards?.[0]?.url ?? '',
    title: value.attachments.cards?.[0]?.title ?? '',
  });

  return (
    <>
      <PostComposerContentText
        value={value}
        onChange={onChange}
        onTextEditorInit={onTextEditorInit}
        onTranslationEditorInit={onTranslationEditorInit}
        swapTextTranslation={swapTextTranslation}
      />
      <PostComposerContentMediaAttachments
        value={value}
        onChange={(patch) => {
          onChange((prev) => {
            const updatedState =
              typeof patch === 'function' ? patch(prev) : patch;

            const [firstCard, ...restCards] =
              updatedState.attachments?.cards ?? [];

            if ((persistedValues.title || persistedValues.url) && firstCard) {
              const newCard = {
                ...firstCard,
                url: persistedValues.url,
                title: persistedValues.title,
              };

              return {
                ...updatedState,
                attachments: {
                  ...updatedState.attachments,
                  cards: [newCard, ...restCards],
                },
              };
            }

            return updatedState;
          });
        }}
        allowedFiles={isVideo ? ['video'] : ['image']}
        maxCount={PostsConfig.MIN_FILES_TO_ACCEPT}
      />
      <PostComposerContentPinterestLinkForm
        defaultValues={{
          url: persistedValues.url,
          title: persistedValues.title,
        }}
        disabled={value.attachments.cards.length === 0}
        onChange={(values) => {
          setPersistedValues({
            url: values.url,
            title: values.title,
          });

          onChange((prev) => ({
            ...prev,
            attachments: {
              ...prev.attachments,
              cards: prev.attachments.cards.map((card) => ({
                ...card,
                url: values.url,
                title: values.title,
              })),
            },
          }));
        }}
      />
    </>
  );
};

export default PostComposerContentPinterest;
